const sizes = {
	sm: 240,
	default: 600,
	lg: 768,
	xl: 1024,
	full: "100%"
};

export default class SliderService {
	static getWidth(size: string | number) {
		if (size == null)
			size = "default";

		let width: string | number = (size in sizes)
			? sizes[size]
			: size;

		if (typeof width === "string") {
			const isNumber = RegExp(/^(\d*)?\d+$/).test(width);
			if (isNumber)
				width = parseInt(width);
		}

		if (typeof width === "number") {
			width = `${width}px`;
		}

		return width;
	}
}